<template>
  <div class="chart-tree-map" ref="chartdiv" :style="{ height: chartSettings.chartHeight ? chartSettings.chartHeight + 'px' : '700px' }"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themesAnimated from '@amcharts/amcharts4/themes/animated'
import { mapGetters } from 'vuex'
import imageOther from '../../assets/label-other.png'
// import * as _ from 'underscore'

export default {
  name: 'chartTreeMapRender',
  props: {
    chartKey: { type: String, required: true },
    fromDialog: { type: Boolean, required: false }
  },
  data () {
    return {
      chartSettings: {},
      chartData: [],
      ppWebUrl: ''
    }
  },
  computed: {
    ...mapGetters(['translation']),
    chartObj: {
      get () { return this.$store.getters.getChartByKey(this.chartKey) }
    }
  },
  created () {
    this.ppWebUrl = process.env.VUE_APP_WEB_URL
  },
  mounted () {
    let self = this
    am4core.useTheme(am4themesAnimated)
    this.chartSettings = this.chartObj.chartSettings
    this.chartData = this.chartObj.data.result

    // check and reduce data if not in dialog
    /* if (!this.fromDialog && this.chartData.length > (this.chartObj.chartSettings.displayLength || 10)) {
      this.chartData = this.chartData.filter((data, index) => index < (this.chartObj.chartSettings.displayLength || 10))
    } */

    // Creating chart instance
    let chart = am4core.create(this.$refs.chartdiv, am4charts.TreeMap)
    chart.data = this.chartData

    // Define data fields
    chart.dataFields.value = 'value'
    chart.dataFields.name = 'name'
    chart.dataFields.children = 'children'
    chart.dataFields.color = 'color' // assign brand color from data via response
    chart.hiddenState.properties.opacity = 0
    chart.maxLevels = 1 // only one level visible initially
    chart.colors.step = self.chartObj.chartSettings.colorSteps || 1 // make the contrast between color steps prominent enough
    chart.zoomOutButton.events.off('hit') // remove default event of zoomOutButton
    chart.zoomOutButton.events.on('hit', () => { chart.zoomToChartDataItem(chart.currentlyZoomed.parent) })// add zoom out per level
    if (this.chartObj.chartSettings.legend) chart.legend = new am4charts.Legend() // enable legend from chart settings

    // level 0 series template
    let level0SeriesTemplate = chart.seriesTemplates.create('0')
    level0SeriesTemplate.strokeWidth = 2
    // by default only current level series bullets are visible, but as we need brand bullets to be visible all the time, we modify it's hidden state
    level0SeriesTemplate.bulletsContainer.hiddenState.properties.opacity = 1
    level0SeriesTemplate.bulletsContainer.hiddenState.properties.visible = true
    // create hover state
    let columnTemplate = level0SeriesTemplate.columns.template
    columnTemplate.tooltipText = `[bold]{name}: {value}`
    let hoverState = columnTemplate.states.create('hover')
    // darken
    hoverState.adapter.add('fill', function (fill, target) {
      if (fill instanceof am4core.Color) {
        return am4core.color(am4core.colors.brighten(fill.rgb, -0.2))
      }
      return fill
    })
    if (!this.chartSettings.hideImage) {
      // add logo
      let image = columnTemplate.createChild(am4core.Image)
      image.opacity = 0.25
      image.align = 'center'
      image.valign = 'middle'
      image.width = am4core.percent(80)
      image.height = am4core.percent(80)
      // apply desaturate filter
      let imageFilter = image.filters.push(new am4core.DesaturateFilter())
      imageFilter.saturation = 0
      // add adapter for href to load correct image
      image.adapter.add('href', function (href, target) {
        let dataItem = target.parent.dataItem
        if (dataItem) {
          if (dataItem.treeMapDataItem.name !== 'Other') {
            return `${self.ppWebUrl}resources/${dataItem.treeMapDataItem.name.toLowerCase().replace(/ /g, '')}/production/logo/logo.png`
          } else {
            return imageOther
          }
        }
      })
    } else {
      // alternative text
      let bullet0 = level0SeriesTemplate.bullets.push(new am4charts.LabelBullet())
      bullet0.locationX = 0.5
      bullet0.locationY = 0.5
      bullet0.label.text = '{name}'
      bullet0.label.fill = am4core.color('#ffffff')
      bullet0.label.fontSize = 16
      bullet0.label.fontWeight = 'bold'
      bullet0.label.fillOpacity = 1
    }

    // level 1 series template
    let levelsOfSeriesTemplates = ['1', '2', '3']
    levelsOfSeriesTemplates.forEach(l => {
      let levelSeriesTemplate = chart.seriesTemplates.create(l)
      levelSeriesTemplate.columns.template.fillOpacity = 0
      levelSeriesTemplate.columns.template.strokeOpacity = 0.4
      levelSeriesTemplate.columns.template.tooltipText = '{parentName} - {name}: {value}'
      // Add labels
      let bullet = levelSeriesTemplate.bullets.push(new am4charts.LabelBullet())
      bullet.locationX = 0.5
      bullet.locationY = 0.5
      bullet.label.text = '{name}: {value}'
      // bullet.label.fill = am4core.color('#ffffff')
      bullet.label.fontSize = 16
      bullet.label.fontWeight = 'bold'
      bullet.label.fillOpacity = 1
    })

    this.chart = chart // assign chart to 'this.chart' to be available for dispose
  },
  beforeDestroy () {
    if (this.chart) this.chart.dispose()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .chart-tree-map {
    width: 100%;
    height: 700px;
  }
</style>
